import React from "react";
import {Route, Switch} from "react-router-dom";
import InternalMentorCardWidgetContainer from "./InternalMentorCardWidget/InternalMentorCardWidget";
import ExternalMentorCardWidgetContainer from "./ExternalMentorCardWidget/ExternalMentorCardWidget";

const MentorCardWidgetRoutes = (parentProps) => (
    <Switch>
        <Route
            path={`${parentProps.match.path}/internal`}
            render={(props) => <InternalMentorCardWidgetContainer {...parentProps} {...props} />}
        />
        <Route
            path={`${parentProps.match.path}/external`}
            render={(props) => <ExternalMentorCardWidgetContainer {...parentProps} {...props} />}
        />
    </Switch>
);

export default MentorCardWidgetRoutes;
